import script from "./FiltersContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FiltersContainer.vue?vue&type=script&setup=true&lang=ts"

import "./FiltersContainer.vue?vue&type=style&index=0&id=73be82fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73be82fb"]])

export default __exports__